@let eventVal = event();

<div
  class="message-container"
  [ngClass]="{
    'left': !userInfo().isCurrentUser && (eventVal | isMessageEvent),
    'right': userInfo().isCurrentUser && (eventVal | isMessageEvent),
    'full-width transparent': (eventVal | isSubmissionEvent) || (eventVal | isAttemptStartedEvent),
    'started': eventVal | isAttemptStartedEvent,
    'participant': !userInfo().isCurrentUser && userInfo().isThreadParticipant && (eventVal | isMessageEvent),
  }"
  >
  <div class="message">
    @if (eventVal | isMessageEvent) {
      <div class="name-section">
        @if (!userInfo().isCurrentUser) {
          <span class="name">{{ userInfo().name }}</span>
        }
        <div class="date"><ng-container *ngTemplateOutlet="sentAt"></ng-container></div>
      </div>
    }
    <div class="bubble">
      @if (eventVal | isMessageEvent) {
        <div
          class="message-event"
          [innerHTML]="(eventVal.text | allowDisplayCodeSnippet : userInfo().isCurrentUser ? 'light' : 'dark') | breakLines"
        ></div>
      }
      @if ((eventVal | isSubmissionEvent) || (eventVal | isAttemptStartedEvent)) {
        @if (eventVal | isSubmissionEvent) {
          <hr class="divider alg-divider">
        }
        <div class="classical-event">
          @if ((eventVal | isSubmissionEvent) && eventVal.score !== undefined) {
            <alg-score-ring
              class="score-ring"
              [currentScore]="eventVal.score"
              [diameter]="32"
            ></alg-score-ring>
          }
          <div>
            <div>
              @if (userInfo().isCurrentUser) {
                <span i18n>
                  You
                </span>
              } @else if (userInfo().isThreadParticipant) {
                <span i18n>
                  The user
                </span>
              } @else if (userInfo().name) {
                <span>
                  {{ userInfo().name }}
                </span>
              } @else {
                <span i18n>
                  An unknown user
                </span>
              }
              @if (userInfo().isCurrentUser) {
                @if (eventVal | isAttemptStartedEvent) {
                  <span i18n="Forum if the subjet is 'you'@@forumYouStartedActivity">started the activity</span>
                }
                @if (eventVal | isSubmissionEvent) {
                  <span i18n="Forum if the subjet is 'you'@@forumYouSubmittedActivity">submitted a</span>
                  @if (itemRoute(); as route) {
                    <a
                      class="alg-link"
                      [ngClass]="{ 'disabled': !canCurrentUserLoadAnswers() }"
                      [routerLink]="route | with: { answer: { id: eventVal.answerId } } | url: ['task', 'editor']"
                      i18n
                      >
                    solution
                  </a>
                  }
                }
              } @else {
                @if (eventVal | isAttemptStartedEvent) {
                  <span i18n="Forum if the subjet is another user@@forumUserStartedActivity">started the activity</span>
                }
                @if (eventVal | isSubmissionEvent) {
                  <span i18n="Forum if the subjet is another user@@forumUserSubmittedActivity">submitted a</span>
                  @if (itemRoute(); as route) {
                    <a
                      class="alg-link"
                      [ngClass]="{ 'disabled': !canCurrentUserLoadAnswers() }"
                      [routerLink]="route | with: { answer: { id: eventVal.answerId } } | url: ['task', 'editor']"
                      i18n
                      >
                    solution
                  </a>
                  }
                }
              }
            </div>
            <div class="date"><ng-container *ngTemplateOutlet="sentAt"></ng-container></div>
          </div>
        </div>
        @if (eventVal | isSubmissionEvent) {
          <hr class="divider alg-divider">
        }
      }
    </div>
  </div>
</div>

<ng-template #sentAt>
  <span i18n>{{ eventVal.time | relativeTime }}</span>
</ng-template>
